export default __webpack_public_path__ + "static/media/circle-4.568e3179.svg";